import photoRoutes from '../photos/routes.js'

const DealerInventory = () => import(
  /* webpackChunkName: "inventory" */
  './Manager/index.vue'
)

export default [
  {
    component: DealerInventory,
    meta: { title: 'Inventory' },
    name: 'inventory',
    path: '/inventory'
  },
  {
    component: () => import('./AddInventory/AddInventory.vue'),
    name: 'inventory.add.new',
    path: '/inventory/add-new',
    meta: { title: 'Add New Inventory', forceRemount: true },
    props: { type: 'new' }
  },
  {
    component: () => import('./AddInventory/AddInventory.vue'),
    name: 'inventory.add.used',
    path: '/inventory/add-used',
    meta: { title: 'Add Used Inventory', forceRemount: true },
    props: { type: 'used' }
  },
  ...photoRoutes({
    name: 'inventory.vehicle.photos.embed',
    path: '/inventory/:id/photos/embed',
    meta: { layout: 'none' },
    defaultTab: 'inventory'
  }),
  {
    component: () => import(
      /* webpackChunkName: "inventory" */
      './VehicleDetails/index.vue'
    ),
    name: 'inventory.vehicle',
    path: '/inventory/:id',
    meta: { fullscreen: true },
    children: [
      ...photoRoutes({
        name: 'inventory.vehicle.photos',
        path: 'photos',
        defaultTab: 'inventory',
        meta: { fullscreen: false }
      }),
      {
        name: 'inventory.vehicle.disclosures',
        path: '/inventory/:id/disclosures',
        meta: { type: 'inventory', fullscreen: false },
        component: () => import(
          /* webpackChunkName: "disclosures.page" */
          '../../components/Disclosures/index.vue'
        )
      },
      {
        name: 'inventory.vehicle.tab',
        path: ':tab(pricing|equipment|options|approval|estock)',
        meta: { fullscreen: true }
      }
    ].filter(Boolean)
  },
  {
    name: 'inventory.vehicle.transfer',
    path: '/inventory/:id/transfer',
    meta: {
      enterprise: true
    },
    component: () => import(
      /* webpackChunkName: "inventory.transfer" */
      './Transfer/index.vue'
    )
  }
]
